import React from 'react';
import { Award, Rocket, Timer, Zap } from 'lucide-react';
import { useGame } from '../contexts/GameContext';
import { useSettings } from '../contexts/SettingsContext';

const GameSetup = () => {
  const { starter, setStarter, startGame } = useGame();
  const { settings } = useSettings();
  
  return (
    <div className="game-card text-center">
      <h2 className="text-2xl font-semibold mb-6 uyghur-text">ئويۇننى قانداق باشلايسىز؟</h2>
      
      <div className="mb-8">
        <h3 className="text-lg font-medium mb-4 uyghur-text">كىم باشلايدۇ؟</h3>
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6">
          <button
            className={`px-6 py-4 rounded-lg flex items-center gap-2 transition-all ${
              starter === 'player' 
                ? 'bg-emerald-500 text-white shadow-md scale-in' 
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
            onClick={() => setStarter('player')}
          >
            <Award size={24} />
            <span className="uyghur-text text-lg">مەن باشلايمەن</span>
          </button>
          <button
            className={`px-6 py-4 rounded-lg flex items-center gap-2 transition-all ${
              starter === 'robot' 
                ? 'bg-blue-500 text-white shadow-md scale-in' 
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
            onClick={() => setStarter('robot')}
          >
            <Rocket size={24} />
            <span className="uyghur-text text-lg">روبوت باشلىسۇن</span>
          </button>
        </div>
      </div>
      
      <div className="mb-8">
        <h3 className="text-lg font-medium mb-4 uyghur-text">قىيىنلىق دەرىجىسى</h3>
        <div className="flex justify-center items-center gap-4">
          <div className="flex items-center gap-1">
            <div className={`w-3 h-3 rounded-full ${settings.difficulty === 'easy' ? 'bg-green-500' : 'bg-gray-300'}`}></div>
            <span className="text-gray-600 uyghur-text">ئاسان</span>
          </div>
          <div className="flex items-center gap-1">
            <div className={`w-3 h-3 rounded-full ${settings.difficulty === 'medium' ? 'bg-yellow-500' : 'bg-gray-300'}`}></div>
            <span className="text-gray-600 uyghur-text">ئوتتۇرا</span>
          </div>
          <div className="flex items-center gap-1">
            <div className={`w-3 h-3 rounded-full ${settings.difficulty === 'hard' ? 'bg-red-500' : 'bg-gray-300'}`}></div>
            <span className="text-gray-600 uyghur-text">قىيىن</span>
          </div>
        </div>
      </div>
      
      {settings.timeLimit > 0 && (
        <div className="mb-8 flex items-center justify-center">
          <Timer size={20} className="text-gray-500 mr-2" />
          <span className="text-gray-600 uyghur-text">
            ۋاقىت چەكلىمىسى: {settings.timeLimit} سېكۇنت
          </span>
        </div>
      )}
      
      <button
        className="btn btn-primary btn-lg flex items-center gap-2 mx-auto"
        onClick={startGame}
      >
        <Zap size={20} />
        <span className="uyghur-text">ئويۇننى باشلاش</span>
      </button>
    </div>
  );
};

export default GameSetup;